var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-detail-content" }, [
    _c("div", { staticClass: "go-detail go-detail-default" }, [
      _c("div", { staticClass: "go-detail-header" }, [
        _c("div", { staticClass: "go-block-top" }, [
          _c("div", { staticClass: "go-card-info" }, [
            _c("div", { staticClass: "go-info-item go-channel" }, [
              _c("span", { staticClass: "go-channel-name" }, [
                _vm._v(
                  _vm._s(
                    _vm.noteData.typeData &&
                      _vm.noteData.typeData.toString() === "[USERNOTE]"
                      ? "My Note"
                      : _vm.noteData.channel
                  )
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.noteData.publishedAt
              ? _c("div", { staticClass: "go-info-item go-datetime" }, [
                  _vm._v(_vm._s(_vm.processDatetimes())),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.noteData.sourceUri
            ? _c("div", { staticClass: "go-elements" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn go-btn-default go-btn-sm",
                    attrs: { type: "button" },
                    on: { click: _vm.newWidowOrigin },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("report.seeOriginalContent")) +
                        "\n          "
                    ),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-detail-title" }, [
          _vm._v("\n        " + _vm._s(_vm.noteData.title) + "\n      "),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "go-detail-body" }, [
        _c("p", [_vm._v(_vm._s(_vm.noteData.content))]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }